/// <reference types="./extra.d.mts" />
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import { Ok, Error, Empty as $Empty, isEqual } from "../../gleam.mjs";

export function push(list, element) {
  let _pipe = list;
  let _pipe$1 = $list.reverse(_pipe);
  let _pipe$2 = $list.prepend(_pipe$1, element);
  return $list.reverse(_pipe$2);
}

export function insert(list, element) {
  let present = $list.contains(list, element);
  return $bool.guard(present, list, () => { return push(list, element); });
}

export function remove(list, element) {
  return $list.filter(list, (e) => { return !isEqual(e, element); });
}

export function slice(l, start, end) {
  let _pipe = $list.drop(l, start);
  return $list.take(_pipe, end - start);
}

export function nth(loop$l, loop$index) {
  while (true) {
    let l = loop$l;
    let index = loop$index;
    if (l instanceof $Empty) {
      return new Error(undefined);
    } else if (index === 0) {
      let fst = l.head;
      return new Ok(fst);
    } else {
      let n = index;
      let rest = l.tail;
      loop$l = rest;
      loop$index = n - 1;
    }
  }
}

export function index_filter(l, f) {
  let _pipe = l;
  let _pipe$1 = $list.index_map(_pipe, (a, i) => { return [a, i]; });
  let _pipe$2 = $list.filter(_pipe$1, (t) => { return f(t[1]); });
  return $list.map(_pipe$2, $pair.first);
}
